import { createDbAuthClient, createAuth } from '@cedarjs/auth-dbauth-web'

const dbAuthClient = createDbAuthClient({
  dbAuthUrl: `${globalThis.RWJS_API_URL}/admin/auth`,
  fetchConfig: { credentials: 'include' },
})

export const { AuthProvider, useAuth } = createAuth(dbAuthClient)
